










































import Vue from 'vue'
import { isInteger, isDate, range } from 'lodash'
import DatePicker from '@/components/workflow/Datepicker.vue'

export default Vue.extend({
  components: {
    DatePicker,
  },
  computed: {
    valueDate: {
      get(): Date {
        if (isInteger(this.value)) {
          return this.asDate(this.value as number)
        } else if (isDate(this.value)) {
          return this.value
        } else {
          throw new Error('value must be integer or date')
        }
      },
      set(value: number | Date) {
        if (isInteger(value)) {
          this.$emit('input', this.asDate(value as number))
        } else if (isDate(value)) {
          return this.$emit('input', value)
        } else {
          throw new Error('value must be integer or date')
        }
      },
    },
    minDate(): Date {
      if (isInteger(this.min)) {
        return this.asDate(this.min as number)
      } else if (isDate(this.min)) {
        return this.min
      } else {
        throw new Error('min must be integer or date')
      }
    },
    maxDate(): Date {
      if (isInteger(this.max)) {
        return this.asDate(this.max as number)
      } else if (isDate(this.max)) {
        return this.max
      } else {
        throw new Error('max must be integer or date')
      }
    },
  },
  props: {
    value: {
      required: true,
      type: [Number, Date],
    },
    min: {
      type: [Number, Date],
      default: 2,
    },
    max: {
      type: [Number, Date],
      default: 19,
    },
  },
  methods: {
    asDate(days: number): Date {
      const asDate = new Date()
      asDate.setDate(asDate.getDate() + days)
      return asDate
    },
    getDate(inDays: number): Date {
      const now: Date = new Date()
      now.setDate(now.getDate() + inDays)
      return now
    },
  },
})
